import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ApiService } from '../../services/api/api.service';
import { FormatService } from '../../services/format/format.service';
import * as moment from "moment";

const TYPE_LABEL: any = {
  monthly: 'Bulanan',
  sixmonthly: '6 Bulan',
  yearly: 'Tahunan',
};

@Component({
  selector: 'app-subscribe-store',
  templateUrl: './subscribe-store.component.html',
  styleUrls: ['./subscribe-store.component.css']
})
export class SubscribeStoreComponent implements OnInit {
  isData : any = [];
  isTotalAll : number = 0;
  isKeyword : string = '';
  isPlatform : string = '';
  isType : string = '';

  isPage : number = 1;
  isPageSize : number = 10;
  isPages : any = [];
  isTableLoading : boolean = false;

  constructor(
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private apiService: ApiService,
    private formatService: FormatService,
  ) { }

  ngOnInit(): void {
    this.isPageSize = this.apiService.LIMIT || 10;
    this.getData();
  }

  private searchTimer : any;
  private lastQuery : string = '';

  onKeywordInput(value : string){
    this.isKeyword = value;
    clearTimeout(this.searchTimer);
    // debounce: wait 450ms after the last keystroke before hitting the API
    this.searchTimer = setTimeout(() => this.applyFilter(), 450);
  }

  async applyFilter(){
    clearTimeout(this.searchTimer);
    const query = `${this.isKeyword}|${this.isPlatform}|${this.isType}`;
    if(query === this.lastQuery){ return; } // query unchanged, skip the request
    this.lastQuery = query;
    this.isPage = 1;
    await this.getData();
  }

  async getData(){
    let searchData = {"keyword":this.isKeyword, "platform":this.isPlatform, "type":this.isType};
    const offset = (this.isPage - 1) * this.isPageSize;
    this.isTableLoading = true;
    try{
      this.apiService.methodGetSilent(`user-store/${offset}/${encodeURIComponent(JSON.stringify(searchData))}`,this.authService.getToken()).subscribe((response)=>{
        this.isTableLoading = false;
        if(response && response.status == 200) {
          this.isData = [];
          (response.total ? response.data.forEach((element: any) => {
            // relations can be null — must never break the render
            element.userName = element.user ? element.user.name : '-';
            element.platformVw = element.platform === 'android' ? 'Play Store'
              : (element.platform === 'ios' ? 'App Store' : (element.platform || '-'));
            element.typeVw = TYPE_LABEL[element.type] || element.type || '-';
            element.priceVw = this.formatService.currency(element.price || 0);
            element.createdVw = moment(element.createdAt).locale('id').format("D MMMM YYYY");
            element.expiredVw = element.expired_date ? moment(element.expired_date).locale('id').format("D MMMM YYYY") : '-';
            element.isActive = element.expired_date ? moment(element.expired_date).isSameOrAfter(moment(), 'day') : false;
            this.isData.push(element);
          }) : false);
          this.isTotalAll = response.total || 0;
          this.buildPager();
        }
      }, () => { this.isTableLoading = false; })
    }catch(error){
      this.isTableLoading = false;
      console.log(error);
    }
  }

  totalPages(){
    return Math.max(1, Math.ceil(this.isTotalAll / this.isPageSize));
  }
  buildPager(){
    const total = this.totalPages();
    const pages: any[] = [];
    for(let p = 1; p <= total; p++){
      if(p == 1 || p == total || Math.abs(p - this.isPage) <= 1){
        pages.push(p);
      }else if(pages[pages.length - 1] != '...'){
        pages.push('...');
      }
    }
    this.isPages = pages;
  }
  async goToPage(p: any){
    const total = this.totalPages();
    if(p < 1 || p > total || p == this.isPage){ return; }
    this.isPage = p;
    await this.getData();
  }
  rowNo(i: number){
    return (this.isPage - 1) * this.isPageSize + i + 1;
  }
  summaryFrom(){
    return this.isTotalAll ? (this.isPage - 1) * this.isPageSize + 1 : 0;
  }
  summaryTo(){
    return (this.isPage - 1) * this.isPageSize + this.isData.length;
  }
  formatNumber(value : any){
    return this.formatService.dotFormat(value || 0);
  }

  // wrap keyword matches in <mark> for the list; input is HTML-escaped first
  highlight(text : any){
    const esc = String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const keyword = this.isKeyword.trim();
    if(!keyword){ return esc; }
    const escapedKeyword = keyword
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // neutralize regex metacharacters
    return esc.replace(new RegExp(`(${escapedKeyword})`, 'gi'), '<mark class="vl-hl">$1</mark>');
  }

  copyText(text : string){
    const done = () => this.toastr.success(`${text} disalin`);
    const nav: any = navigator;
    if(nav.clipboard && nav.clipboard.writeText){
      nav.clipboard.writeText(text).then(done);
    }else{
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      done();
    }
  }
}
